(ns storrito.connect3.two-factor-notification-panel
  "Panel for the legacy 2FA flow's `two-factor-notification-required`
   status: Instagram sent a login-approval notification to the user's
   Instagram app. The PHP side blocks on this request — every reply
   triggers exactly one approval poll at Instagram, and the loop allows
   four polls before it reports `iteration-limit-reached`. The button
   therefore acks explicitly instead of auto-polling on a timer, so the
   pace stays with the user."
  (:require [storrito.connect3.common :as common]
            [storrito.connect3.notification-approval-panel :as notification-approval-panel]
            [storrito.ui.button :as button]
            [storrito.util.link :as link]))

(defn- pending-hint
  "Shown from the second request on: the previous poll came back without
   an approval."
  [state]
  (when (pos? (or (:requestsCount state) 0))
    [:div.w-full.bg-amber-50.border.border-amber-200.rounded-xl.p-4.mb-4.text-left
     [:p.text-sm.text-amber-800
      [:i.fas.fa-hourglass-half.mr-2]
      "We haven't seen your approval yet. Open the Instagram app, tap "
      [:b "\"Approve\""]
      ", then confirm below again."]]))

(defn panel
  [state]
  [:div.flex.items-center.justify-center
   [:div.bg-white.shadow-xl.rounded-2xl.px-8.pt-6.pb-6.max-w-5xl.w-full.mx-auto.flex.flex-col.items-center
    (common/instagram-logo)
    [:h2.text-2xl.font-bold.text-gray-900.mt-2.mb-1.text-center.w-full
     "Approve This Login"]
    [:p.text-sm.text-gray-500.text-center.mb-4
     "Instagram sent a login request to your Instagram app. Open the app
      on your phone and tap "
     [:b "\"Approve\""]
     " (or \"This was me\")."]

    (notification-approval-panel/trust-banner state)

    (pending-hint state)

    (notification-approval-panel/approve-steps)

    [:div.w-full
     [:a.inline-block.text-sm.text-blue-600.hover:underline.font-medium
      {:href (link/help-center-url "fd390648-13a9-47b3-affb-71a5aad2f636")
       :target "_blank"}
      [:i.fas.fa-question-circle.fa-sm.mr-1]
      "Need help? View detailed instructions"]
     (common/error-message state)
     (button/button-primary-lg
       {:class "w-full mt-3"
        :on {:click [[:connect3/send! {:device-approved true}]]}}
       "I have approved the login")]]])
